import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {CommonService} from './../../_services/common.service';
import {FormBuilder,Validators,FormGroup} from '@angular/forms';
import {HttpRequestService} from './../../_services/http-request.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import {Router, ActivatedRoute} from '@angular/router';
@Component({
  selector: 'app-forget-password-reset',
  templateUrl: './forget-password-reset.component.html',
  styleUrls: ['./forget-password-reset.component.scss']
})
export class ForgetPasswordResetComponent implements OnInit {

  forgetPasswordForm: FormGroup;
  constructor(
    public formBuilder: FormBuilder,
    public translate: TranslateService,
    private cService: CommonService,
    private httpRequestService: HttpRequestService,
    private toastr: ToastrService,
    private router:Router, 
    private activatedRoute: ActivatedRoute
    ) {
    this.cService.activelang.subscribe((lang) => {
      
      // this language will be used as a fallback when a translation isn't found in the current language
      translate.setDefaultLang(lang);

      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use(lang);
    });
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((paramData)=>{
      if (paramData.token) {
        this.forgetPasswordForm = this.formBuilder.group({
          lang:[localStorage.getItem('_lang')],
          token:[paramData.token],
          password:['', [Validators.required]],
          confirm_password:['', [Validators.required]]
        });    
      }
  });
    
  }

  forgetPasswordFromSubmit() {
    if (this.forgetPasswordForm.valid) {
			let confirmCheck = (this.forgetPasswordForm.value.password == this.forgetPasswordForm.value.confirm_password);
			if (!confirmCheck) {
        this.translate.get(['CONFIRM_NEW_PASSWORD_MISMATCH']).subscribe((tData)=>{
          this.toastr.error( tData['CONFIRM_NEW_PASSWORD_MISMATCH'],'Error:');
        })
			} else {
				this.httpRequestService.setModule('action').post('forget_password_reset_action',this.forgetPasswordForm.value).subscribe((response) => {
					if(response.status === 'error') {
						this.toastr.error( response.data,'Error:');
					} else {
						this.translate.get([
							'SUCCESS'
						]).subscribe((tData)=>{
	
							Swal.fire(tData['SUCCESS'], response.data, 'success')
							.then((result)=>{
								this.router.navigate(['']);
							})
						})
					}
				});
			}
		}
  }

}
